const userIsLoggedIn = siteData.is_user_logged_in ? true : false
const wpRestNonce = siteData.wp_rest_nonce
const userAgent = window.navigator.userAgent.toLowerCase()
const isIos = /iphone|ipad|ipod/.test( userAgent )
const nativeConnection = !! window.navigator.connection

const initialState = {
	// User:
	userIsLoggedIn: userIsLoggedIn,
	wpRestNonce: wpRestNonce,

	// Device:
	isIos: isIos,
	screenWidth: window.innerWidth,
	screenHeight: window.innerHeight,
	isMobile: window.innerWidth <= siteData.mobile_max_width,

	// Connection:
	connection: {
		onLine: true,
		possiblySlowNetwork: false, // Guessed connection speed when nativeConnection is not available.
		downlink: nativeConnection ? navigator.connection.downlink : false, // Megabits per second.
		rtt: nativeConnection ? navigator.connection.rtt : false, // Ms.
		effectiveType: nativeConnection ? navigator.connection.effectiveType : false, // 'slow-2g', '2g', '3g', or '4g'.
	},

	// Scripts:
	loadedScripts: [],

	// DKE:
	metaData: siteData.meta ? JSON.parse( siteData.meta ) : false,
	sectionData: siteData.sections ? JSON.parse( siteData.sections ) : false,

	// Site:
	siteHasLoaded: false,
	menuIsOpen: false,
	menuItems: siteData.site_menu,
	menuItemsSecondary: siteData.site_menu_secondary
}

export default function reducer( state = initialState, action ) {
	const { payload } = action

	switch ( action.type ) {
		case 'SET_SITE_LOADED':
			return {
				...state,
				siteHasLoaded: true
			}

		case 'ADD_SCRIPT':
			return {
				...state,
				loadedScripts: [
					...state.loadedScripts,
					payload
				]
			}

		case 'GET_SCREEN_SIZE':
			return {
				...state,
				screenWidth: window.innerWidth,
				screenHeight: window.innerHeight,
				isMobile: window.innerWidth <= siteData.mobile_max_width
			}

		case 'SET_ONLINE_STATUS':
			return {
				...state,
				connection: {
					...state.connection,
					onLine: payload
				}
			}

		case 'SET_CONNECTION_STATUS':
			return {
				...state,
				connection: {
					...state.connection,
					...payload
				}
			}

		case 'OPEN_MENU':
			return {
				...state,
				menuIsOpen: true
			}

		case 'CLOSE_MENU':
			return {
				...state,
				menuIsOpen: false
			}

		case 'SET_MENU_OPEN_STATE':
			return {
				...state,
				menuIsOpen: payload
			}

		case 'REQUEST_MENU_DATA':
			return {
				...state,
				isLoadingMenu: true
			}

		case 'RECEIVE_MENU_DATA':
			return {
				...state,
				isLoadingMenu: false,
				menuItems: payload.site_menu,
				menuItemsSecondary: payload.site_menu_secondary
			}

		case 'RECEIVE_SITE_DATA':
			return {
				...state,
				menuItems: payload.site_menu,
				menuItemsSecondary: payload.site_menu_secondary
			}
	}

	return state
}



// WEBPACK FOOTER //
// ./redux/reducers/site.jsx